import api from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getVisibilidadeProcessos = async () => {
    let processos = null;
    try {
        const response = await api.get(`Visibilidade/list`, config);
        processos = response.data.data;
    } catch (err) { }
    return processos;
}

export const getOptionAllVisibilidade = async () => {
    let processos = null;
    try {
        const response = await api.get(`Visibilidade/check-all-visibilidade`, config);
        processos = response.data.data;
    } catch (err) { }
    return processos;
}

export const getVisibilidadeTarefas = async () => {
    let tarefas = null;
    try {
        const response = await api.get(`Visibilidade/tarefa`, config);
        tarefas = response.data.data;
    } catch (err) { }
    return tarefas;
}

export const getVisibilidadeJornadas = async () => {
    let jornadas = null;
    try {
        const response = await api.get(`Visibilidade/jornada/listcontroller`, config);
        jornadas = response.data.data;
    } catch (err) { }
    return jornadas;
}

export const getVisibilidadeEtapas = async () => {
    let etapas = null;
    try {
        const response = await api.get(`Visibilidade/etapa/listcontroller`, config);
        etapas = response.data.data;
    } catch (err) { }
    return etapas;
}

export const getVisibilidadeMacroEtapas = async () => {
    let etapasMacro = null;
    try {
        const response = await api.get(`Visibilidade/macroetapa/listcontroller`, config);
        etapasMacro = response.data.data;
    } catch (err) { }
    return etapasMacro;
}

export const getGeneriList = async (codeType) => {
    let synisterStatus = null;
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Credentials': false
        },
        params: { codeType }
    }
    try {
        const response = await api.get(`Settings/genericlist/list`, config);
        synisterStatus = response.data.data;
    } catch (err) { }
    return synisterStatus;
}

export const getTarefaExecutaAcao = async (idTipoAcao) => {
    let tarefas = null;
    try {
        const response = await api.get(`Visibilidade/tarefa/executa/acao/${idTipoAcao}`, config);
        tarefas = response.data.data;
    } catch (err) { }
    return tarefas;
}

